import { ReactNode } from 'react';

interface PageLayoutProps {
  pageTitle: string;
  children: ReactNode;
  action1?: ReactNode;
  action2?: ReactNode;
}

function PageLayout({
  pageTitle,
  children,
  action1,
  action2,
}: PageLayoutProps) {
  return (
    <div className="bg-[#F6F6F6] min-h-screen w-screen md:w-full font-poppins ">
      <div className="fixed top-16 left-0 lg:left-64 right-0 z-30 mt-4 bg-white px-5 h-16 flex items-center border-b-[0.5px] border-[#D4D4D4]" >
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <h1 className="font-medium text-sm sm:text-lg text-[#1b1b1b] truncate">
            {pageTitle}
          </h1>

          {action1 && <div className="flex items-center">{action1}</div>}
        </div>
        <div className="flex items-center gap-2 justify-end">
          {action2 && <div className="flex items-center">{action2}</div>}
        </div>
      </div>
      <div className="pt-16">{children}</div>
    </div>
  );
}

export default PageLayout;
